import { render } from "./PPCManagementPage.vue?vue&type=template&id=5c69d894"
import script from "./PPCManagementPage.vue?vue&type=script&lang=js"
export * from "./PPCManagementPage.vue?vue&type=script&lang=js"

import "./PPCManagementPage.vue?vue&type=style&index=0&id=5c69d894&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__